import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface TableActionMenuProps {
  isOpen: boolean;
  anchorEl: HTMLElement | null;
  children: React.ReactNode;
  className?: string;
}

export const TableActionMenu: React.FC<TableActionMenuProps> = ({
  isOpen,
  anchorEl,
  children,
  className = ''
}) => {
  const [style, setStyle] = useState<React.CSSProperties>({});

  // useLayoutEffect y no useEffect: la posición tiene que estar puesta antes
  // de pintar. Con useEffect el menú se pintaba un fotograma sin 'fixed', al
  // final del body, y hacía aparecer la barra de scroll de la página.
  useLayoutEffect(() => {
    if (!isOpen || !anchorEl) return;

    const updatePosition = () => {
      const rect = anchorEl.getBoundingClientRect();
      setStyle({
        position: 'fixed',
        top: rect.bottom,
        right: window.innerWidth - rect.right,
        zIndex: 9999,
        marginTop: '0.25rem'
      });
    };

    updatePosition();
    window.addEventListener('scroll', updatePosition, true);
    window.addEventListener('resize', updatePosition);

    return () => {
      window.removeEventListener('scroll', updatePosition, true);
      window.removeEventListener('resize', updatePosition);
    };
  }, [isOpen, anchorEl]);

  if (!isOpen || !anchorEl) return null;

  return createPortal(
    <div
      className={className}
      style={style}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>,
    document.body
  );
};
